import React from 'react';
import { motion } from 'framer-motion';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .tpln-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .tpln-page { font-family: 'Inter', sans-serif; color: #0f172a; background: #ffffff; width: 100%; }

  /* ─── Hero ─────────────────────────────────────────────────── */
  .tpln-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .tpln-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 520px; height: 520px; border-radius: 50%; background: radial-gradient(circle, rgba(99,102,241,0.14), rgba(139,92,246,0.06)); filter: blur(80px); pointer-events: none; }
  .tpln-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(14,165,233,0.1), rgba(56,189,248,0.05)); filter: blur(90px); pointer-events: none; }
  .tpln-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .tpln-hero-inner { grid-template-columns: 1fr; } .tpln-hero-visual { display: none; } }
  .tpln-back-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.18s ease; margin-bottom: 24px; }
  .tpln-back-btn:hover { background: #eef2ff; border-color: #c7d2fe; color: #4f46e5; }
  .tpln-hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #eef2ff; border: 1px solid #c7d2fe; font-size: 13px; font-weight: 500; color: #3730a3; margin-bottom: 28px; }
  .tpln-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: #6366f1; display: inline-block; animation: tpln-pulse 2s infinite; }
  @keyframes tpln-pulse { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(99,102,241,0.4);}50%{opacity:.85;box-shadow:0 0 0 6px rgba(99,102,241,0);} }
  .tpln-hero h1 { font-size: clamp(1.8rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0f172a; margin-bottom: 24px; }
  .tpln-gradient-text { background: linear-gradient(135deg, #4f46e5, #0ea5e9); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .tpln-hero p { font-size: 1.15rem; color: #475569; line-height: 1.75; margin-bottom: 40px; font-weight: 300; max-width: 520px; }
  .tpln-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .tpln-btn-primary { padding: 14px 28px; background: #4f46e5; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .tpln-btn-primary:hover { background: #3730a3; box-shadow: 0 8px 24px rgba(79,70,229,0.35); transform: translateY(-1px); }
  .tpln-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1.5px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .tpln-btn-secondary:hover { border-color: #c7d2fe; background: #eef2ff; color: #3730a3; }

  /* Hero Visual */
  .tpln-hero-visual { background: #fff; border-radius: 28px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(79,70,229,0.08); }
  .tpln-vis-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .tpln-vis-title p:first-child { font-size: 11px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px; }
  .tpln-vis-title p:last-child { font-size: 17px; font-weight: 800; color: #0f172a; }
  .tpln-vis-icon { width: 46px; height: 46px; background: linear-gradient(135deg, #4f46e5, #6366f1); border-radius: 13px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .tpln-timeline { display: flex; flex-direction: column; gap: 10px; margin-bottom: 18px; }
  .tpln-tl-item { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border-radius: 11px; border: 1px solid #f1f5f9; background: #f8fafc; }
  .tpln-tl-quarter { width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 800; flex-shrink: 0; }
  .tpln-tl-quarter.q1 { background: #eef2ff; color: #4f46e5; }
  .tpln-tl-quarter.q2 { background: #f0fdf4; color: #059669; }
  .tpln-tl-quarter.q3 { background: #fffbeb; color: #d97706; }
  .tpln-tl-quarter.q4 { background: #fdf4ff; color: #9333ea; }
  .tpln-tl-content { flex: 1; }
  .tpln-tl-title { font-size: 13px; font-weight: 700; color: #334155; margin-bottom: 2px; }
  .tpln-tl-desc { font-size: 11px; color: #94a3b8; }
  .tpln-tl-saving { font-size: 12px; font-weight: 700; color: #059669; }
  .tpln-vis-total { padding: 16px; background: linear-gradient(135deg, #4f46e5, #6366f1); border-radius: 13px; display: flex; justify-content: space-between; align-items: center; }
  .tpln-vis-total span:first-child { font-size: 13px; color: rgba(255,255,255,0.75); font-weight: 500; }
  .tpln-vis-total span:last-child { font-size: 19px; font-weight: 900; color: #fff; }

  /* ─── Stats ─────────────────────────────────────────────────── */
  .tpln-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .tpln-stats-grid { display: grid; grid-template-columns: repeat(4,1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .tpln-stats-grid { grid-template-columns: repeat(2,1fr); } }
  .tpln-stat { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .tpln-stat:last-child { border-right: none; }
  @media (max-width: 768px) { .tpln-stat:nth-child(2n){ border-right:none; } .tpln-stat{ border-bottom:1px solid #f1f5f9; } }
  .tpln-stat-num { font-size: 2.2rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; color: #4f46e5; }
  .tpln-stat-num.dark { color: #0f172a; }
  .tpln-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ─── Section Base ───────────────────────────────────────────── */
  .tpln-section { padding: 96px 24px; }
  .tpln-container { max-width: 1200px; margin: 0 auto; }
  .tpln-section-header { text-align: center; max-width: 700px; margin: 0 auto 64px; }
  .tpln-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .tpln-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.75; }
  .tpln-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #4f46e5; margin-bottom: 12px; }

  /* ─── Why Plan ───────────────────────────────────────────────── */
  .tpln-why { background: #f8fafc; }
  .tpln-why-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
  @media (max-width: 900px) { .tpln-why-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .tpln-why-grid { grid-template-columns: 1fr; } }
  .tpln-why-card { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; padding: 32px; transition: all 0.3s; position: relative; overflow: hidden; }
  .tpln-why-card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background: linear-gradient(90deg,#4f46e5,#0ea5e9); transform:scaleX(0); transform-origin:left; transition:transform 0.3s; }
  .tpln-why-card:hover::before { transform:scaleX(1); }
  .tpln-why-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); border-color: #c7d2fe; }
  .tpln-why-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 24px; margin-bottom: 20px; }
  .tpln-why-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 10px; }
  .tpln-why-card p { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── Process ───────────────────────────────────────────────── */
  .tpln-process { background: #fff; }
  .tpln-process-inner { background: #0f172a; border-radius: 32px; padding: 80px 64px; position: relative; overflow: hidden; }
  @media (max-width: 900px) { .tpln-process-inner { padding: 48px 32px; } }
  .tpln-proc-glow1 { position: absolute; top: 0; right: 0; width: 400px; height: 400px; background: radial-gradient(circle, rgba(99,102,241,0.22), transparent 70%); pointer-events: none; }
  .tpln-proc-glow2 { position: absolute; bottom: 0; left: 0; width: 350px; height: 350px; background: radial-gradient(circle, rgba(14,165,233,0.13), transparent 70%); pointer-events: none; }
  .tpln-proc-header { text-align: center; margin-bottom: 64px; position: relative; z-index: 1; }
  .tpln-proc-header .tpln-label { color: #a5b4fc; }
  .tpln-proc-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .tpln-proc-header p { font-size: 1.05rem; color: #94a3b8; margin-top: 16px; line-height: 1.7; }
  .tpln-quarters { display: grid; grid-template-columns: repeat(4,1fr); gap: 24px; position: relative; z-index: 1; }
  @media (max-width: 900px) { .tpln-quarters { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 500px) { .tpln-quarters { grid-template-columns: 1fr; } }
  .tpln-q-card { background: rgba(30,41,59,0.5); border: 1px solid rgba(71,85,105,0.4); border-radius: 20px; padding: 28px; transition: border-color 0.3s; }
  .tpln-q-card:hover { border-color: rgba(99,102,241,0.5); }
  .tpln-q-badge { display: inline-block; padding: 4px 12px; border-radius: 999px; font-size: 12px; font-weight: 700; margin-bottom: 18px; }
  .tpln-q-badge.q1 { background: rgba(99,102,241,0.2); color: #a5b4fc; }
  .tpln-q-badge.q2 { background: rgba(16,185,129,0.2); color: #6ee7b7; }
  .tpln-q-badge.q3 { background: rgba(245,158,11,0.2); color: #fcd34d; }
  .tpln-q-badge.q4 { background: rgba(236,72,153,0.2); color: #f9a8d4; }
  .tpln-q-card h3 { font-size: 1.05rem; font-weight: 700; color: #f1f5f9; margin-bottom: 12px; }
  .tpln-q-list { display: flex; flex-direction: column; gap: 8px; }
  .tpln-q-item { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; color: #94a3b8; line-height: 1.5; }
  .tpln-q-dot { width: 5px; height: 5px; border-radius: 50%; background: #94a3b8; flex-shrink: 0; margin-top: 7px; }

  /* ─── Strategies ─────────────────────────────────────────────── */
  .tpln-strategies { background: #f8fafc; }
  .tpln-strat-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }
  @media (max-width: 768px) { .tpln-strat-grid { grid-template-columns: 1fr; } }
  .tpln-strat-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 20px; padding: 28px 32px; display: flex; gap: 20px; align-items: flex-start; transition: all 0.3s; }
  .tpln-strat-card:hover { border-color: #c7d2fe; box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .tpln-strat-emoji { font-size: 28px; flex-shrink: 0; margin-top: 2px; }
  .tpln-strat-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
  .tpln-strat-card p { font-size: 0.9rem; color: #64748b; line-height: 1.65; margin-bottom: 12px; }
  .tpln-strat-saving { display: inline-block; padding: 4px 12px; background: #eef2ff; color: #4f46e5; border-radius: 999px; font-size: 12px; font-weight: 700; }

  /* ─── Who Benefits ───────────────────────────────────────────── */
  .tpln-who { background: #fff; }
  .tpln-who-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 900px) { .tpln-who-inner { grid-template-columns: 1fr; gap: 48px; } }
  .tpln-who-left h2 { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .tpln-who-left > p { font-size: 1.05rem; color: #64748b; line-height: 1.75; margin-bottom: 36px; }
  .tpln-who-list { display: flex; flex-direction: column; gap: 14px; }
  .tpln-who-item { display: flex; align-items: flex-start; gap: 14px; padding: 16px 18px; background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 12px; transition: all 0.2s; }
  .tpln-who-item:hover { background: #eef2ff; border-color: #c7d2fe; }
  .tpln-who-icon { font-size: 20px; flex-shrink: 0; margin-top: 1px; }
  .tpln-who-text h4 { font-size: 14px; font-weight: 700; color: #1e293b; margin-bottom: 4px; }
  .tpln-who-text p { font-size: 13px; color: #64748b; line-height: 1.55; }
  .tpln-who-visual { background: #0f172a; border-radius: 24px; padding: 40px; position: relative; overflow: hidden; }
  .tpln-who-vis-glow { position: absolute; top: 0; right: 0; width: 250px; height: 250px; background: radial-gradient(circle, rgba(99,102,241,0.25), transparent 70%); pointer-events: none; }
  .tpln-savings-label { font-size: 12px; color: #94a3b8; font-weight: 500; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 8px; }
  .tpln-savings-amount { font-size: 3rem; font-weight: 900; color: #fff; letter-spacing: -0.04em; margin-bottom: 6px; }
  .tpln-savings-sub { font-size: 14px; color: #64748b; margin-bottom: 36px; }
  .tpln-savings-rows { display: flex; flex-direction: column; gap: 12px; }
  .tpln-savings-row { display: flex; justify-content: space-between; align-items: center; }
  .tpln-savings-row span:first-child { font-size: 13px; color: #94a3b8; }
  .tpln-savings-row span:last-child { font-size: 13px; font-weight: 700; color: #a5b4fc; }
  .tpln-savings-divider { height: 1px; background: rgba(255,255,255,0.07); margin: 16px 0; }
  .tpln-savings-total { display: flex; justify-content: space-between; align-items: center; }
  .tpln-savings-total span:first-child { font-size: 14px; font-weight: 600; color: #e2e8f0; }
  .tpln-savings-total span:last-child { font-size: 18px; font-weight: 900; color: #6ee7b7; }

  /* ─── FAQ ───────────────────────────────────────────────────── */
  .tpln-faq { background: #f8fafc; }
  .tpln-faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
  @media (max-width: 768px) { .tpln-faq-grid { grid-template-columns: 1fr; } }
  .tpln-faq-item { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 26px; transition: all 0.2s; }
  .tpln-faq-item:hover { border-color: #c7d2fe; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .tpln-faq-q { font-size: 0.98rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; display: flex; gap: 10px; align-items: flex-start; }
  .tpln-faq-q-icon { width: 22px; height: 22px; border-radius: 6px; background: #eef2ff; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #4f46e5; flex-shrink: 0; margin-top: 1px; }
  .tpln-faq-a { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── CTA ────────────────────────────────────────────────────── */
  .tpln-cta { background: #fff; border-top: 1px solid #f1f5f9; padding: 96px 24px; }
  .tpln-cta-inner { background: #0f172a; border-radius: 32px; padding: 80px 48px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 600px) { .tpln-cta-inner { padding: 48px 24px; } }
  .tpln-cta-glow1 { position: absolute; top: 0; right: 0; width: 360px; height: 360px; background: radial-gradient(circle, rgba(99,102,241,0.28), transparent 70%); pointer-events: none; }
  .tpln-cta-glow2 { position: absolute; bottom: 0; left: 0; width: 300px; height: 300px; background: radial-gradient(circle, rgba(14,165,233,0.15), transparent 70%); pointer-events: none; }
  .tpln-cta-inner h2 { font-size: clamp(2rem,4vw,3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 20px; position: relative; z-index: 1; }
  .tpln-cta-inner p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 540px; margin: 0 auto 40px; line-height: 1.75; position: relative; z-index: 1; }
  .tpln-cta-btns { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 36px; }
  .tpln-cta-primary { padding: 16px 32px; background: #4f46e5; color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 4px 20px rgba(79,70,229,0.4); }
  .tpln-cta-primary:hover { background: #3730a3; transform: translateY(-1px); }
  .tpln-cta-secondary { padding: 16px 32px; background: rgba(255,255,255,0.06); color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .tpln-cta-secondary:hover { background: rgba(255,255,255,0.1); }
  .tpln-cta-badges { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .tpln-cta-badge { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #94a3b8; }
  .tpln-cta-badge-check { color: #a5b4fc; }
`;

const fadeIn = { initial:{opacity:0,y:28}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-50px'}, transition:{duration:0.55} };
const stagger = (i:number) => ({ initial:{opacity:0,y:24}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-40px'}, transition:{duration:0.5,delay:i*0.1} });

const whyPlan = [
  { icon:'💡', bg:'#eef2ff', title:'Tax Decisions Have a Shelf Life', desc:'Many tax-saving opportunities expire December 31. Without a plan, you miss strategies that can only be implemented during the year — not after it.' },
  { icon:'📉', bg:'#f0fdf4', title:'Estimated Tax Penalties Are Avoidable', desc:'The IRS charges underpayment penalties throughout the year. Proactive planning eliminates these entirely through proper withholding and estimates.' },
  { icon:'🏗️', bg:'#fffbeb', title:'Entity Structure Changes Take Time', desc:'Restructuring your business for tax efficiency — from sole prop to S-Corp, for example — requires lead time, legal steps, and planning.' },
  { icon:'🎯', bg:'#fdf4ff', title:'Retirement Contributions Have Annual Limits', desc:'Solo 401(k), SEP-IRA, and SIMPLE IRA strategies require ongoing contribution tracking to maximize limits without overcontributing.' },
  { icon:'📊', bg:'#f0fdfa', title:'Income Shifting Requires Foresight', desc:'Moving income between years, family members, or entities can dramatically reduce your tax rate — but only if planned in advance.' },
  { icon:'🚀', bg:'#fff7ed', title:'Business Milestones Create Tax Events', desc:'Raising capital, selling assets, hiring employees, or expanding to new states all create tax implications that need proactive management.' },
];

const quarters = [
  { cls:'q1', label:'Q1 — Jan to Mar', title:'Kickoff & Foundation', items:['Review prior year return & identify missed opportunities','Establish estimated tax payment schedule','Set up bookkeeping & chart of accounts','Review payroll setup and officer compensation'] },
  { cls:'q2', label:'Q2 — Apr to Jun', title:'Mid-Year Strategy', items:['Q1 estimated payment due (Apr 15)','Review YTD income vs. projections','Evaluate retirement contribution pace','Assess equipment & asset purchase timing'] },
  { cls:'q3', label:'Q3 — Jul to Sep', title:'Optimization Window', items:['Q2 estimated payment due (Jun 15)','Income projection update & adjustment','Entity structure review checkpoint','Year-end bonus and deferral planning begins'] },
  { cls:'q4', label:'Q4 — Oct to Dec', title:'Year-End Execution', items:['Q3 estimated payment due (Sep 15)','Execute year-end strategies before Dec 31','Finalize retirement contributions','Harvest tax losses in investment accounts'] },
];

const strategies = [
  { emoji:'🏛️', title:'Entity Structure Optimization', desc:'Selecting and maintaining the right business entity — LLC, S-Corp, C-Corp — can reduce self-employment taxes by $5,000–$20,000+ annually for qualifying businesses.', saving:'Save up to $20K/yr' },
  { emoji:'🪙', title:'Retirement Plan Maximization', desc:'Solo 401(k)s, SEP-IRAs, and defined benefit plans allow business owners to shelter $20,000–$300,000+ in pre-tax income depending on plan type and income level.', saving:'Up to $300K sheltered' },
  { emoji:'📉', title:'Income Timing & Deferral', desc:'Strategic timing of invoicing, expenses, and income recognition across tax years can shift you into a lower bracket and reduce your effective tax rate significantly.', saving:'10–25% rate reduction' },
  { emoji:'👨‍👩‍👧', title:'Family Employment Strategies', desc:'Employing family members in your business at reasonable compensation shifts income to lower-bracket taxpayers, reduces your business income, and can fund their IRAs.', saving:'$5K–$30K per family member' },
  { emoji:'🏠', title:'Qualified Business Income (QBI) Deduction', desc:'Pass-through entities may qualify for a 20% deduction on qualified business income. We optimize your compensation structure to maximize this benefit.', saving:'20% income deduction' },
  { emoji:'🔬', title:'R&D Tax Credits', desc:'Many businesses qualify for research and development credits that reduce tax liability dollar-for-dollar — not just a deduction. Qualifying activities are broader than most assume.', saving:'Dollar-for-dollar credit' },
];

const whoItems = [
  { icon:'📈', title:'Rapidly Growing Businesses', desc:'As revenue grows, so does your tax exposure. Planning ahead prevents a painful April surprise.' },
  { icon:'💼', title:'Business Owners Considering a Sale', desc:'Exit planning 2–3 years out can reduce capital gains taxes by hundreds of thousands of dollars.' },
  { icon:'🏢', title:'Owners Expanding to New States', desc:'New states mean new nexus, new filing obligations, and potential double-taxation without proactive management.' },
  { icon:'👤', title:'High-Income Self-Employed', desc:'SE tax, quarterly estimates, and retirement strategies are critical for self-employed individuals earning $150K+.' },
];

const faqs = [
  { q:'How is tax planning different from tax preparation?', a:'Tax preparation is reactive — it reports what happened last year. Tax planning is proactive — it shapes decisions throughout the year to reduce what you owe. Both are important, but planning is where the biggest savings are found.' },
  { q:'When should I start tax planning?', a:'The best time is January 1. The second best time is today. Many strategies — like entity restructuring, retirement contributions, and income deferral — require lead time to implement effectively.' },
  { q:'How much does tax planning cost?', a:'We offer flat-fee annual planning engagements that include quarterly reviews, projection updates, and unlimited access to your advisor. Most clients see a return of 5–10x our fee in actual tax savings.' },
  { q:'Do I need tax planning if I already file on time?', a:'Filing on time is compliance — it\'s the minimum. Planning is where you reduce what you owe before the return is even prepared. Even clients who file perfectly often overpay thousands.' },
  { q:'What\'s included in a quarterly planning session?', a:'Each session covers a YTD income review, updated tax projections, strategy implementation check-ins, estimated payment calculations, and any new tax law updates affecting your situation.' },
  { q:'Can you work with my existing bookkeeper or CFO?', a:'Absolutely. We collaborate with your full financial team. Better coordination between bookkeeping, payroll, and tax planning leads to better outcomes and no duplicated effort.' },
];

const TaxPlanning: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div className="tpln-page">
    <style>{styles}</style>

    {/* Hero */}
    <section className="tpln-hero">
      <div className="tpln-hero-blob1" /><div className="tpln-hero-blob2" />
      <div className="tpln-hero-inner">
        <div>
          {onBack && (
            <button type="button" className="tpln-back-btn" onClick={onBack}>
              <span aria-hidden="true">←</span> Back to Tax Services
            </button>
          )}
          <motion.div initial={{opacity:0,scale:0.9}} animate={{opacity:1,scale:1}} transition={{duration:0.5}}>
            <div className="tpln-hero-badge"><span className="tpln-badge-dot" />Year-round strategy, not just April filing</div>
          </motion.div>
          <motion.h1 initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.1}}>
            Stop Reacting.<br /><span className="tpln-gradient-text">Start Planning.</span>
          </motion.h1>
          <motion.p initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.2}}>
            The biggest tax savings don't happen in April — they happen in January, June, and October. Our year-round tax planning puts strategy at the center of every business decision you make.
          </motion.p>
          <motion.div className="tpln-btn-group" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5,delay:0.3}}>
            <button type="button" className="tpln-btn-primary">Start Tax Planning →</button>
            <button type="button" className="tpln-btn-secondary">See How It Works</button>
          </motion.div>
        </div>
        <motion.div className="tpln-hero-visual" initial={{opacity:0,x:40}} animate={{opacity:1,x:0}} transition={{duration:0.7,delay:0.2}}>
          <div className="tpln-vis-header">
            <div className="tpln-vis-title"><p>2024 Annual Tax Plan</p><p>Acme Consulting LLC</p></div>
            <div className="tpln-vis-icon">🗓️</div>
          </div>
          <div className="tpln-timeline">
            {[
              {cls:'q1',quarter:'Q1',title:'Entity conversion to S-Corp executed',saving:'-$11,200 SE tax'},
              {cls:'q2',quarter:'Q2',title:'Solo 401(k) established & funded',saving:'-$22,500 taxable income'},
              {cls:'q3',quarter:'Q3',title:'Equipment purchased under Section 179',saving:'-$18,400 deduction'},
              {cls:'q4',quarter:'Q4',title:'Year-end bonus deferral & HSA max',saving:'-$9,600 income'},
            ].map((item,i) => (
              <div className="tpln-tl-item" key={i}>
                <div className={`tpln-tl-quarter ${item.cls}`}>{item.quarter}</div>
                <div className="tpln-tl-content">
                  <div className="tpln-tl-title">{item.title}</div>
                </div>
                <div className="tpln-tl-saving">{item.saving}</div>
              </div>
            ))}
          </div>
          <div className="tpln-vis-total">
            <span>Total Tax Reduction</span>
            <span>$61,700</span>
          </div>
        </motion.div>
      </div>
    </section>

    {/* Stats */}
    <div className="tpln-stats">
      <div className="tpln-stats-grid">
        {[
          {num:'$61K',label:'Average Annual Tax Savings',dark:false},
          {num:'4x',label:'Average Return on Planning Fee',dark:false},
          {num:'Q1–Q4',label:'Year-Round Engagement',dark:true},
          {num:'15+',label:'Years of Tax Strategy Experience',dark:true},
        ].map((s,i) => (
          <motion.div className="tpln-stat" key={i} {...stagger(i)}>
            <div className={`tpln-stat-num${s.dark?' dark':''}`}>{s.num}</div>
            <div className="tpln-stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Why Plan */}
    <section className="tpln-section tpln-why">
      <div className="tpln-container">
        <motion.div className="tpln-section-header" {...fadeIn}>
          <span className="tpln-label">Why It Matters</span>
          <h2>Why Filing On Time Isn't Enough</h2>
          <p>Compliance keeps you out of trouble. Planning keeps money in your pocket. Here's what you're missing without a proactive strategy.</p>
        </motion.div>
        <div className="tpln-why-grid">
          {whyPlan.map((item,i) => (
            <motion.div className="tpln-why-card" key={i} {...stagger(i)}>
              <div className="tpln-why-icon" style={{background:item.bg}}>{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Quarterly Process */}
    <section className="tpln-section tpln-process">
      <div className="tpln-container">
        <div className="tpln-process-inner">
          <div className="tpln-proc-glow1" /><div className="tpln-proc-glow2" />
          <motion.div className="tpln-proc-header" {...fadeIn}>
            <span className="tpln-label">Our Approach</span>
            <h2>A Dedicated Quarter for Every Strategic Priority</h2>
            <p>Our quarterly planning model ensures nothing slips through the cracks and every opportunity is captured in real time.</p>
          </motion.div>
          <div className="tpln-quarters">
            {quarters.map((q,i) => (
              <motion.div className="tpln-q-card" key={i} {...stagger(i)}>
                <div className={`tpln-q-badge ${q.cls}`}>{q.label}</div>
                <h3>{q.title}</h3>
                <div className="tpln-q-list">
                  {q.items.map((item,j) => (
                    <div className="tpln-q-item" key={j}><span className="tpln-q-dot" />{item}</div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Strategies */}
    <section className="tpln-section tpln-strategies">
      <div className="tpln-container">
        <motion.div className="tpln-section-header" {...fadeIn}>
          <span className="tpln-label">Core Strategies</span>
          <h2>The Strategies That Move the Needle Most</h2>
          <p>These are the highest-impact planning strategies we implement for small business owners — legally, methodically, and documented.</p>
        </motion.div>
        <div className="tpln-strat-grid">
          {strategies.map((s,i) => (
            <motion.div className="tpln-strat-card" key={i} {...stagger(i)}>
              <span className="tpln-strat-emoji">{s.emoji}</span>
              <div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <span className="tpln-strat-saving">{s.saving}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Who Benefits */}
    <section className="tpln-section tpln-who">
      <div className="tpln-container">
        <div className="tpln-who-inner">
          <motion.div className="tpln-who-left" {...fadeIn}>
            <span className="tpln-label">Who It's For</span>
            <h2>Tax Planning Makes the Most Impact For…</h2>
            <p>While every business benefits from planning, these situations represent the highest return on a proactive tax strategy.</p>
            <div className="tpln-who-list">
              {whoItems.map((item,i) => (
                <motion.div className="tpln-who-item" key={i} {...stagger(i)}>
                  <span className="tpln-who-icon">{item.icon}</span>
                  <div className="tpln-who-text"><h4>{item.title}</h4><p>{item.desc}</p></div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          <motion.div className="tpln-who-visual" initial={{opacity:0,x:30}} whileInView={{opacity:1,x:0}} viewport={{once:true}} transition={{duration:0.6,delay:0.2}}>
            <div className="tpln-who-vis-glow" />
            <div className="tpln-savings-label">Average Annual Savings</div>
            <div className="tpln-savings-amount">$38,400</div>
            <div className="tpln-savings-sub">Per engaged planning client (FY 2024)</div>
            <div className="tpln-savings-rows">
              {[
                {label:'Entity optimization',val:'$11,200'},
                {label:'Retirement contributions',val:'$9,800'},
                {label:'Section 179 / bonus depreciation',val:'$7,400'},
                {label:'QBI deduction',val:'$6,200'},
                {label:'Income timing strategies',val:'$3,800'},
              ].map((row,i) => (
                <div className="tpln-savings-row" key={i}>
                  <span>{row.label}</span><span>{row.val}</span>
                </div>
              ))}
            </div>
            <div className="tpln-savings-divider" />
            <div className="tpln-savings-total">
              <span>Total Annual Reduction</span>
              <span>$38,400</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="tpln-section tpln-faq">
      <div className="tpln-container">
        <motion.div className="tpln-section-header" {...fadeIn}>
          <span className="tpln-label">Common Questions</span>
          <h2>Everything You Should Know About Tax Planning</h2>
          <p>Still unsure? Reach out — we're happy to walk through your specific situation with no obligation.</p>
        </motion.div>
        <div className="tpln-faq-grid">
          {faqs.map((f,i) => (
            <motion.div className="tpln-faq-item" key={i} {...stagger(i)}>
              <div className="tpln-faq-q"><div className="tpln-faq-q-icon">?</div>{f.q}</div>
              <div className="tpln-faq-a">{f.a}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="tpln-cta">
      <div className="tpln-cta-inner">
        <div className="tpln-cta-glow1" /><div className="tpln-cta-glow2" />
        <motion.h2 {...fadeIn}>Your Best Tax Year Starts Now</motion.h2>
        <motion.p {...{...fadeIn,transition:{duration:0.55,delay:0.1}}}>
          Every month without a plan is money left on the table. Let's build your personalized tax strategy and start capturing savings before year-end.
        </motion.p>
        <motion.div className="tpln-cta-btns" {...{...fadeIn,transition:{duration:0.5,delay:0.2}}}>
          <button type="button" className="tpln-cta-primary">Start My Tax Plan →</button>
          <button type="button" className="tpln-cta-secondary">Schedule a Free Call</button>
        </motion.div>
        <motion.div className="tpln-cta-badges" {...{...fadeIn,transition:{duration:0.5,delay:0.3}}}>
          {['Year-round engagement','Quarterly check-ins included','Licensed CPAs only','Cancel anytime'].map((b,i) => (
            <div className="tpln-cta-badge" key={i}><span className="tpln-cta-badge-check">✓</span>{b}</div>
          ))}
        </motion.div>
      </div>
    </section>
  </div>
);

export default TaxPlanning;
